import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
`;
const FilterBox = styled.div`
  width: 100%;
  padding: 8px 16px 42px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FilterOptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const FilterRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const FilterLabel = styled.div`
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  color: #000;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const FilterRowContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const PlusButton = styled.button`
  padding: 12px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #008aff;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
`;
const SelectedRegionBox = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
`;
const RegionTag = styled.div`
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 999px;
  border: 1px solid #e1e2e4;
  background-color: rgba(112, 115, 124, 0.05);
  font-size: 12px;
  font-weight: 500;
  color: #616161;
`;

const InputBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const FilterInputWrapper = styled.div`
  flex: 1;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
`;
const FilterInput = styled.input`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  padding-right: 8px;
  outline: none;
  border: none;
  background-color: transparent;
  font-size: 14px;

  -webkit-appearance: none;
  appearance: none;

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const MinMaxText = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  line-height: 145%;
`;
const DateInput = styled.input`
  width: 100%;
  height: 40px;
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 8px;
  border: none;
  padding: 0 12px;

  -webkit-appearance: none;
  appearance: none;

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const ResetButton = styled.button`
  width: 57px;
  height: 41px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background-color: #fff;
  font-size: 12px;
  font-weight: 400;
  color: #616161;
  cursor: pointer;
`;
const ApplyButton = styled.button`
  flex: 1;
  height: 41px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  background-color: #008aff;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
`;
const TabButtonBox = styled.div`
  width: 100%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
`;
const TabButton = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: ${({ isActive }) => (isActive ? '1px solid #008AFF' : 'none')};
  background-color: ${({ isActive }) => (isActive ? '#fff' : 'transparent')};
  box-shadow: ${({ isActive }) =>
    isActive
      ? '0px 2px 8px 0px rgba(56, 58, 59, 0.12), 0px 1px 4px 0px rgba(56, 58, 59, 0.08), 0px 0px 1px 0px rgba(56, 58, 59, 0.08)'
      : 'none'};
  font-size: 14px;
  font-weight: 500;
  color: ${({ isActive }) => (isActive ? '#008AFF' : '#989BA2')};
  cursor: pointer;
`;
const EasyFilterBox = styled.div`
  width: 100%;
  padding: 8px 16px 16px 16px;
`;
const FilterInner = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0px 4px 24px 0px rgba(61, 69, 78, 0.1);
`;
export const s = {
  Container,
  FilterBox,
  FilterOptionBox,
  FilterRow,
  FilterLabel,
  FilterRowContent,
  PlusButton,
  SelectedRegionBox,
  RegionTag,
  InputBox,
  FilterInputWrapper,
  FilterInput,
  MinMaxText,
  DateInput,
  ButtonBox,
  ResetButton,
  ApplyButton,
  TabButtonBox,
  TabButton,
  EasyFilterBox,
  FilterInner,
};
